import { MenuItem, Page } from "../types";
import { handleApiError } from "../utils/utils";
import { ApiResponse } from "./auth";
import apiClient from "./index";

export const getMenu = async (
  page: number = 0,
  size: number = 10,
  categories?: string[],
  dishName?: string,
  servingDateTo?: string,
  servingDateFrom?: string
): Promise<ApiResponse<Page<MenuItem>>> => {
  try {
    const params: Record<string, string | number | string[] | undefined> = {
      page,
      size,
      dishName,
      servingDateTo,
      servingDateFrom,
    };
    if (categories && categories.length) {
      params.categories = categories.filter(
        (category) =>
          category.toLowerCase() !== "all" && category.toLowerCase() !== "tous"
      );
    }
    console.log("Fetching menu with params:", params);
    const url = "/dish-availabilities";
    const response = await apiClient.get(url, {
      params,
      headers: { "X-Request-Source": "user" },
    });
    return { data: response.data, error: null };
  } catch (error) {
    return handleApiError(
      error,
      "An unknown error occurred during fetching menu."
    );
  }
};

export const getMenuItem = async (
  id: number
): Promise<ApiResponse<MenuItem | undefined>> => {
  try {
    const response = await apiClient.get(`/menu-items/${id}`);
    return { data: response.data, error: null };
  } catch (error) {
    return handleApiError(
      error,
      "An unknown error occurred during fetching menu."
    );
  }
};
